import { fetchCompanyTools } from "plg/api/plgCompany";
import { cleanTools, isMyTool } from "components/Screens/Marketplace/Customer/utils/tools";

/**
 * tool_match: the talent knows at least one of the customer's own tools (sign-up / Company page), the
 * same match as "Knows X, like your team" on the profile. PLG only (reads the PLG company profile).
 */
export async function plgToolMatch(talentTools: string[] | undefined): Promise<boolean> {
  const mine = await fetchCompanyTools();
  return cleanTools(talentTools || []).some((t) => isMyTool(t, mine));
}
